<main>
  <section>
    <div *ngIf="infoLoaded == 0" class="row justify-content-center page-loading ptb-240"></div>
    <div *ngIf="infoLoaded == 1 && !hasError" class="container custom-container-detail ptb-120 px-5 px-lg-0">
      <div class="card p-3 bdr-r-10">
        <div class="card-header bg-white">
          <div class="flex-sm-row flex-column-reverse justify-content-between">
            <div class="col my-auto">
              <p *ngIf="reservation.status == 'PENDING'" class="fw-700 m-0">{{'reservationDetail.title' | translate}}</p>
              <p *ngIf="reservation.status == 'PENDING'">{{'reservationDetail.subtitle' | translate}}</p>
              <h6 class="col-12 fw-900">{{'reservationDetail.id' | translate}}<span class="color-primary ps-1">{{reservation.identifier}}</span></h6>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row justify-content-between mt-4">
            <div class="col-12"><h6 class="fw-900 fs-18px">{{'reservationDetail.personalInformation' | translate}}</h6></div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <div class="row justify-content-between">
                <div class="col-auto"><p class="mb-1 fw-700">{{'reservationDetail.name' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{reservation.name}}</p></div>
              </div>
              <div class="row justify-content-between">
                <div class="col-auto"><p class="mb-1 fw-700">{{'reservationDetail.nif' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{maskVat(reservation.vat)}}</p></div>
              </div>
              <div class="row justify-content-between">
                <div class="col-auto"><p class="mb-1 fw-700">{{'reservationDetail.email' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{maskEmail(reservation.email)}}</p></div>
              </div>
              <div class="row justify-content-between">
                <div class="col-auto"><p class="mb-1 fw-700">{{'reservationDetail.contact' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{maskPhoneNumber(reservation.phone)}}</p></div>
              </div>
            </div>
          </div>
          <div class="row justify-content-between mt-4">
            <div class="col-12"><h6 class="fw-900 fs-18px">{{'reservationDetail.information' | translate}}</h6></div>
          </div>

          <!-- ----- Esconder aqui se estiver em modo de edição de reserva ----- -->
          <div class="row mt-2">
            <div class="col">
              <div class="row justify-content-between">
                <div class="col-auto"><p class="mb-1 fw-700">{{'reservationDetail.date' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{reservation.date | date:'dd-MM-yyyy'}}</p></div>
              </div>
              <div class="row justify-content-betwee">
                <div class="col-auto"><p class="mb-1 fw-700">{{'reservationDetail.hour' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{reservation.hour}}</p></div>
              </div>
              <div class="row justify-content-between">
                <div class="col-auto"><p class="mb-1 fw-700">{{'reservationDetail.municipality' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{reservation.municipality}}</p></div>
              </div>
              <div class="row justify-content-between">
                <div class="col-auto"><p class="mb-1 fw-700">{{'reservationDetail.line' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{reservation.line}}</p></div>
              </div>
              <div class="row justify-content-between">
                <div class="col-auto"><p class="mb-1 fw-700">{{'reservationDetail.stop' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{reservation.stop}}</p></div>
              </div>
              <div *ngIf="reservation.operator && reservation.operator != 'CIMTS'" class="row justify-content-between d-flex align-items-center">
                <div class="col-auto"><p class="mb-1 fw-700">{{'reservationDetail.operator' | translate}}:</p></div>
                <div class="col-auto mb-3 d-flex align-items-center">
                  <ng-container *ngFor="let logo of lineOperatorLogos; let i = index" >
                      <img
                        [src]="'assets/img/logos/operators/' + logo + '.png'"
                        [alt]="logo"
                        class="p-3 logo-footer"/>
                      <span *ngIf="i < lineOperatorLogos.length -1">/</span>
                    </ng-container>
                </div>
              </div>
              <div class="row justify-content-between mt-4">
                <div class="col-auto"><p class="mb-1 fw-800">{{'reservationDetail.reservationDate' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{reservation.createdAt | date:'dd-MM-yyyy HH:mm:ss'}}</p></div>
              </div>
            </div>
          </div>

          <div *ngIf="editEnabled" class="row">

            <div class="row justify-content-between mt-4">
              <div class="col-12"><h6 class="fw-900 fs-18px">{{'reservationDetail.edition' | translate}}</h6></div>
            </div>
            <form *ngIf="showEditForm" class="edit-form" [formGroup]="formEditReserve" (ngSubmit)="saveEditReservation()">

              <!-- Municipaly Selection -->
              <div class="align-items-center form-group col-12 mb-3">
                <label aria-label="Município" class="mb-1">{{'formLabels.municipio' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                <select aria-label="Selecionar Município" class="form-select" formControlName="municipality" [ngClass]="{ 'is-invalid': submitted && fE['municipality'].errors }">
                  <option value="" selected>{{'formPlaceholders.selecionar' | translate}}</option>
                  <option *ngFor="let municipality of municipalities" value="{{municipality.code}}">{{municipality.name}}</option>
                </select>
                <div *ngIf="submitted && fE['municipality'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
              </div>

              <!-- Line Selection -->
              <div class="form-group col-12 mb-3">
                <label aria-label="Linha" class="mb-1">{{'formLabels.linha' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                <select aria-label="Selecionar Linha" class="form-select" formControlName="line" [ngClass]="{ 'is-invalid': submitted && fE['line'].errors }">
                  <option value="" selected>{{'formPlaceholders.selecionar' | translate}}</option>
                  <option *ngFor="let line of lines" value="{{line.codeCIM}}">{{line.number}} - {{line.name}}</option>
                </select>
                <div *ngIf="submitted && fE['line'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
              </div>

              <!-- Line input -->
              <div *ngIf="lineOperatorEdit != ''" class="col-12 mb-3 d-flex align-items-center">
                <label aria-label="Operador" class="mb-1">{{'formLabels.operador' | translate}}:&nbsp;</label>
                <ng-container *ngFor="let logo of lineOperatorLogosEdit; let i = index" >
                  <img
                    [src]="'assets/img/logos/operators/' + logo + '.png'"
                    [alt]="logo"
                    class="p-3 logo-footer"/>
                  <span *ngIf="i < lineOperatorLogosEdit.length -1">/</span>
                </ng-container>

              </div>

              <!-- Unknown Operator -->
              <div *ngIf="unknownOperatorEdit" class="row justify-content-center align-items-center">
                <div class="col-12">
                  <div class="alert alert-warning">
                    <p class="m-0">{{ 'formFeedback.unknownOperator' | translate }}</p>
                  </div>
                </div>
              </div>

              <!-- Stop Selection -->
              <div class="form-group col-12 mb-3">
                <label aria-label="Paragem" class="mb-1">{{'formLabels.paragem' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                <select aria-label="Selecionar Paragem" class="form-select" formControlName="stop" [ngClass]="{ 'is-invalid': submitted && fE['stop'].errors }">
                  <option value="" selected>{{'formPlaceholders.selecionar' | translate}}</option>
                  <option *ngFor="let stop of stops" value="{{stop.id}}">{{stop.code}} - {{stop.name}}</option>
                </select>
                <div *ngIf="submitted && fE['stop'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
              </div>

              <!-- Date input -->
              <div class="form-group col-12 mb-3">
                <label aria-label="Data" class="mb-1">{{'formLabels.data' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                <input type="text" class="form-control" bsDatepicker [bsValue]="bsValueDay" [bsConfig]="bsConfig" formControlName="date" [ngClass]="{ 'is-invalid': submitted && fE['date'].errors }" >
                <div *ngIf="submitted && fE['date'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
              </div>

              <!-- Hour Selection -->
              <div class="form-group col-12 mb-3">
                <label aria-label="Horário" class="mb-1">{{'formLabels.horario' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                <select aria-label="Selecionar Horário" class="form-select" formControlName="hour" [ngClass]="{ 'is-invalid': submitted && fE['hour'].errors }">
                  <option value="" selected>{{'formPlaceholders.selecionar' | translate}}</option>
                  <option *ngFor="let hour of hours" value="{{hour.realtimeArrivalDesc}}">{{hour.realtimeArrivalDesc}}</option>
                </select>
                <div *ngIf="submitted && fE['hour'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
              </div>

              <!-- Error (working hours) -->
              <div *ngIf="errorWorkingHours" class="row justify-content-center align-items-center">
                <div class="col-12">
                  <div class="alert alert-danger">
                    <!-- <p class="m-0">{{ 'formFeedback.errorReservationWorkingHoursLine1' | translate }}</p> -->
                    <p class="m-0">{{ 'formFeedback.errorReservationWorkingHoursLine2' | translate }}</p>
                    <p class="m-0 fw-800">{{ 'formFeedback.errorReservationWorkingHoursLine3' | translate }}</p>
                  </div>
                </div>
              </div>

              <div class="form-group col-12 mb-3">
                <label aria-label="Mensagem" class="mb-1">{{'formLabels.mensagem' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                <textarea class="form-control" placeholder="{{'formPlaceholders.editMessage' | translate}}" formControlName="message" [ngClass]="{ 'is-invalid': submitted && fE['message'].errors }" style="height: 120px"></textarea>
                <div *ngIf="submitted && fE['message'].errors" class="invalid-feedback">
                  <div *ngIf="fE['message'].errors['required']">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                  <div *ngIf="fE['message'].errors['minlength']">{{'formErrorFeedback.editReservationMinLength' | translate}}</div>
                  <div *ngIf="fE['message'].errors['maxlength']">{{'formErrorFeedback.editReservationMaxLength' | translate}}</div>
                </div>
              </div>

              <!-- CheckBox Accept Terms Accessibility -->
              <div class="form-group col-12 my-2">
                <div class="form-check">
                  <input type="checkbox" id="acceptTermsEdit" formControlName="acceptTermsEdit" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && fE['acceptTermsEdit'].errors }"/>
                  <label aria-label="Checkbox Termos e Condições Acessibilidade" for="acceptTermsEdit" class="form-check-label fs-12px">{{'formPlaceholders.termosAdesaoReservaText1.1' | translate}} <a [routerLink]="'/direitos-deveres'" target="_blank">{{'formPlaceholders.termosAdesaoReservaText1.2' | translate}}</a>{{'formPlaceholders.termosAdesaoReservaText1.3' | translate}}</label>
                  <div *ngIf="submitted && fE['acceptTermsEdit'].errors" class="invalid-feedback">{{'formErrorFeedback.termosObrigatorio' | translate}}</div>
                </div>
              </div>

              <!-- CheckBox Accept Terms General -->
              <div class="form-group col-12 my-2">
                <div class="form-check">
                  <input type="checkbox" id="acceptTermsAccessibilityEdit" formControlName="acceptTermsAccessibilityEdit" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && fE['acceptTermsAccessibilityEdit'].errors }"/>
                  <label aria-label="Checkbox Termos e Condições" for="acceptTermsAccessibilityEdit" class="form-check-label fs-12px">
                    {{'formPlaceholders.termosAdesaoReservaText2.1' | translate}}<a [routerLink]="'/politica-privacidade'" target="_blank" class="fw-700">
                      {{'navLinks.politicaPrivacidade' | translate}}</a>{{'formPlaceholders.termosAdesaoReservaText2.2' | translate}}
                  </label>
                  <div *ngIf="submitted && fE['acceptTermsAccessibilityEdit'].errors" class="invalid-feedback">{{'formErrorFeedback.termosObrigatorio' | translate}}</div>
                </div>
              </div>

              <div *ngIf="editEnabled" class="row justify-content-end align-items-center">
                <div class="col-auto my-3">
                  <button (click)="cancelEditReservation()" type="button" class="btn btn-outline-secondary me-4" title="Limpar Formulário">
                    <p class="m-0 fw-600">{{'buttons.cancelar' | translate}}<i class="uil uil-times fs-20px ms-2"></i></p>
                  </button>
                  <button type="submit" class="btn btn-primary" title="Enviar Formulário">
                    <p class="m-0 fw-600">{{'buttons.enviar' | translate}}<i class="uil uil-arrow-up-right fs-20px ms-2 color-white"></i></p>
                  </button>
                </div>
              </div>

            </form>

            <!-- Loading Message -->
            <div *ngIf="inProgress" class="row justify-content-center align-items-center">
              <div class="col-12">
                <div class="alert alert-warning">
                  <p class="m-0">{{ 'formFeedback.submittingMember' | translate }}</p>
                  <p class="m-0">{{ 'formFeedback.pleaseWait' | translate }}</p>
                </div>
              </div>
            </div>

            <!-- Success Info -->
            <div *ngIf="successEdit" class="row justify-content-center align-items-center">
              <div class="col-12">
                <div class="alert alert-sucess">
                  <p class="m-0">{{ 'formFeedback.successEditReservationInfoLine1' | translate }}</p>
                  <p class="m-0">{{ 'formFeedback.successEditReservationInfoLine2' | translate }}</p>
                  <p class="m-0 fw-800">{{ 'formFeedback.successEditReservationInfoLine3' | translate }}</p>
                </div>
              </div>
            </div>

            <!-- Error (general) Info -->
            <div *ngIf="errorEdit" class="row justify-content-center align-items-center">
              <div class="col-12">
                <div class="alert alert-warning">
                  <p class="m-0">{{ 'formFeedback.errorEditReservationLine1' | translate }}</p>
                  <p class="m-0 fw-800">{{ 'formFeedback.errorEditReservationLine2' | translate }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ----- Esconder aqui se estiver em modo de edição de reserva ----- -->
        <div *ngIf="!editEnabled" class="card-footer">
          <div class="statusComplain">
            <div class="row justify-content-between align-items-center my-3">
              <div class="col-auto"><h6 class="m-0 fs-20px fw-900">{{'reservationDetail.status' | translate}}:</h6></div>
              <div *ngIf="reservation.status == 'PENDING'" class="col-auto"><span class="badge rounded-pill text-bg-warning">{{'reservationDetail.analysis' | translate}}</span></div>
              <div *ngIf="reservation.status == 'APPROVED'" class="col-auto"><span class="badge rounded-pill text-bg-success">{{'reservationDetail.approved' | translate}}</span></div>
              <div *ngIf="reservation.status == 'FINISHED'" class="col-auto"><span class="badge rounded-pill text-bg-dark">{{'reservationDetail.finished' | translate}}</span></div>
              <div *ngIf="reservation.status == 'REJECTED'" class="col-auto"><span class="badge rounded-pill text-bg-danger">{{'reservationDetail.rejected' | translate}}</span></div>
              <div *ngIf="reservation.status == 'CANCELED'" class="col-auto"><span class="badge rounded-pill text-bg-dark">{{'reservationDetail.canceled' | translate}}</span></div>
            </div>
            <ng-container *ngIf="reservation.status != 'PENDING' && reservation.status != 'CANCELED'">
              <div class="row justify-content-between">
                <div class="col-12"><p class="m-0 fw-700">{{'complaintDetail.notes' | translate}}:</p></div>
                <div class="col-12"><p class="notes-content">{{reservation.notes}}</p></div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- ======= Buttons ======= -->

      <!-- ----- Esconder aqui se estiver em modo de edição de reserva ----- -->
      <ng-container *ngIf="!editEnabled">
        <div class="row justify-content-between align-items-center">
            <div *ngIf="canDelete" class="col-auto my-3">
              <button (click)="enableCancelReservation(contentModalCancel)" type="button" class="btn btn-outline-secondary" title="Cancelar Reserva"><p class="m-0 fw-600">{{'reservationDetail.cancelReservation' | translate}}<i class="uil uil-times fs-20px ms-2"></i></p></button>
            </div>
            <div *ngIf="canEdit" class="col-auto my-3">
              <button [disabled]="errorWorkingHours" (click)="enableEditReservation()" type="submit" class="btn btn-primary" title="Editar Reserva"><p class="m-0 fw-600">{{'reservationDetail.editReservation' | translate}}<i class="uil uil-edit fs-20px ms-2 color-white"></i></p></button>
            </div>
        </div>

        <div *ngIf="errorWorkingHours" class="row justify-content-center align-items-center">
          <div class="col-12">
            <div class="alert alert-warning mt-3">
              <p class="fs-14px m-0">{{'reservationDetail.errorMinimumWorkingHoursEdit' | translate}}</p>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- ----- End Esconder aqui se estiver em modo de edição de reserva ----- -->

      <!-- ======= End  Buttons ======= -->
    </div>

    <div *ngIf="hasError" class="container custom-container-detail ptb-120 px-4 px-lg-0">
      <div class="row justify-content-center align-items-center">
        <div class="col-12">
          <div class="alert alert-warning bdr-r-10">
            <p class="m-0">{{'reservationDetail.errorTitle' | translate}}</p>
            <p class="m-0">{{'reservationDetail.errorSubtitle1' | translate}}</p>
            <p class="m-0 fw-800">{{'reservationDetail.errorSubtitle2' | translate}}</p>
          </div>
        </div>
      </div>
      <div class="row justify-content-between">
        <div class="col-auto my-3 p-0">
          <button title="Botão Contactos" class="btn-custom btn-3" [routerLink]="'/contactos'"><span><p class="my-auto fw-600">{{'navLinks.contactos' | translate}}</p><i class="uil uil-arrow-up-right color-white ms-2"></i></span></button>
        </div>
        <div class="col-auto my-3 p-0">
          <button title="Botão ir para Início" class="btn-custom btn-3" (click)="goHome()"><span><p class="my-auto fw-600">{{'buttons.goToHome' | translate}}</p><i class="uil uil-arrow-up-right color-white ms-2"></i></span></button>
        </div>
      </div>
    </div>
  </section>
</main>

<!-- ======= Modal Cancel Reservation ======= -->
<ng-template #contentModalCancel let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{'reservationDetail.cancelReservation' | translate}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <p>{{ 'reservationDetail.cancelReservationText' | translate }}</p>
    <form class="edit-form" [formGroup]="formCancelReserve" (ngSubmit)="cancelReservation()">
      <div class="form-group col-12 mb-3">
        <label aria-label="Mensagem" class="mb-1">{{'formLabels.mensagem' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
        <textarea class="form-control" placeholder="{{'formPlaceholders.cancelMessage' | translate}}" formControlName="message" [ngClass]="{ 'is-invalid': submittedDelete && fCR['message'].errors }" style="height: 120px"></textarea>
        <div *ngIf="submittedDelete && fCR['message'].errors" class="invalid-feedback">
          <div *ngIf="fCR['message'].errors['required']">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
          <div *ngIf="fCR['message'].errors['minlength']">{{'formErrorFeedback.cancelReservationMinLength' | translate}}</div>
          <div *ngIf="fCR['message'].errors['maxlength']">{{'formErrorFeedback.cancelReservationMaxLength' | translate}}</div>
        </div>
      </div>
    </form>
    <div *ngIf="errorWorkingHours" class="row justify-content-center align-items-center">
      <div class="col-12">
        <div class="alert alert-warning mt-3">
          <p class="fs-14px m-0">{{'reservationDetail.errorMinimumWorkingHoursDelete' | translate}}</p>
        </div>
      </div>
    </div>

    <div *ngIf="errorEdit" class="row justify-content-center align-items-center">
      <div class="col-12">
        <div class="alert alert-danger">
          <p class="m-0">{{ 'formFeedback.errorEditReservationLine1' | translate }}</p>
          <p class="m-0 fw-800">{{ 'formFeedback.errorEditReservationLine2' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary me-4" title="Voltar" (click)="modal.close('Close click')">
      <p class="m-0 fw-600">{{'buttons.voltar' | translate}}<i class="uil uil-left fs-20px ms-2"></i></p>
    </button>
    <button (click)="cancelReservation()" type="button" class="btn btn-primary" title="Cancelar Reserva">
      <p class="m-0 fw-600">{{'reservationDetail.cancelReservation' | translate}}<i class="uil uil-times fs-20px ms-2"></i></p>
    </button>

  </div>
</ng-template>
